
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    icon: String
  }
})
export default class TextButton extends Vue {
  icon!: string
}
